import { findIndex, uniq } from 'lodash/array'
import { find, reject } from 'lodash/collection'

export const move = (someArray, fromIndex, toIndex) => {
  if (fromIndex === null && toIndex === null) return array
  someArray.splice(toIndex, 0, someArray.splice(fromIndex, 1)[0])
  return someArray
}

export const getAfterId = (entityId, haystack) => {
  let matchedIndex = findIndex(haystack, (x) => x.entity.id === entityId)
  try {
    return haystack[matchedIndex - 1].entity.id
  } catch (error) {
    return 0
  }
}

export const updateEntities = (boardItems, entitiesDiff) =>
  boardItems.map((wrp) => {
    let match = find(entitiesDiff, { entity: wrp.entity })
    return match || wrp
  })

export const slideItem = (kanbanItems, shiftObj) => {
  // frontend-side slide
  return new Promise((resolve, reject) => {
    const { removedIndex, addedIndex, item, to_state } = shiftObj
    let itemList = kanbanItems[to_state]

    const moved = move(itemList, removedIndex, addedIndex)
    let after_id = getAfterId(item.entity.id, moved)

    let updated = { ...kanbanItems }
    // fake the positions until we hear back from the backend
    updated[to_state] = moved.map((x, idx) => ({ ...x, position: idx }))

    resolve({ kanbanItems: updated, after_id })
  })
}

export const moveItem = (kanbanItems, transObj) => {
  // frontend-side transition
  return new Promise((resolve, reject) => {
    const { from_state, to_state, addedIndex, item } = transObj

    let res = { ...item, state: to_state }
    let fromList = [...kanbanItems[from_state]]
    let toList = [...kanbanItems[to_state]]

    let removed = fromList.filter((x) => x.entity.id !== item.entity.id)
    toList.splice(addedIndex, 0, res)

    let after_id = getAfterId(item.entity.id, toList)

    let updated = { ...kanbanItems }
    // fake the positions until we hear back from the backend
    updated[from_state] = removed.map((x, idx) => ({ ...x, position: idx }))
    updated[to_state] = toList.map((x, idx) => ({ ...x, position: idx }))

    resolve({ kanbanItems: updated, after_id })
  })
}

export const sortByPosition = (arr) => arr.concat().sort((a, b) => a.position > b.position)

export const groupByState = (arr) => groupByState(arr, 'state')

export const addToOrUpdateList = (haystack, needle) => {
  let match = find(haystack, { id: needle.id })
  if (match) {
    return haystack.map((item) => (item.id === needle.id ? needle : item))
  }
  return [...haystack, needle]
}

export const makeCardURL = (boardRef, entityId) => `${window.location.origin}/boards/${boardRef}/cards/${entityId}`

// Extra validators for action/transition/guard names
export const isMachineReadable = (value) => /^[0-9a-z-]*$/.test(value)

// Return a list of items with merged principal attributes
export const addPrincipalInfo = (users, principals, attributions, type) => {
  return users
    .map((user) => {
      let match = principals.find((item) => item.principal_id === user.id)
      if (!match) {
        // couldn't find that principal in our list. skipping
        return
      }
      let attribution = attributions.find((attr) => attr.value === match.attribution)
      if (!attribution) {
        // couldn't find that attribution in our list. skipping
        return
      }
      return {
        ...user,
        type,
        attribution: match.attribution,
        attributionName: attribution.name
      }
    })
    .filter((el) => !!el)
}

export const makeTransitionList = (addTo, removeFrom, attr, value) => {
  let added = addTo.map((item) => {
    item[attr] = uniq([...item[attr], value])
    return item
  })
  let trimmed = removeFrom.map((item) => {
    item[attr] = reject(item[attr], (v) => v === value)
    return item
  })
  return [...added, ...trimmed]
}
